export default __webpack_public_path__ + "static/media/al_flag.32245881.svg";